import React from "react";
import { NavLink } from "react-router-dom";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";

import { searchNavImages } from "../imagesData/ImagesData";
import useFetchImageUrls from "../ConstantUseFetchImageUrls";

function Searchnav() {
  const query = `params=${encodeURIComponent(JSON.stringify(searchNavImages))}`;
  const { imageUrls, error } = useFetchImageUrls(query);
  if (error) return <div>Error loading images.</div>;
  return (
    <>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row">
            <div class="searchnav-box">
              <img
                src={imageUrls?.imageUrl?.img1}
                class="acc-logo"
                alt="logo"
              />
              <p class="desktop-tag">
                <span>Learning & Talent Transformation</span> <br />{" "}
                <p className="desktop-tag-1" style={{ color: "#0041F0" }}>
                  ABC University
                </p>
              </p>
              <p class="mobile-tag">
                <span>L&TT</span> <br />{" "}
                <p className="mobile-tag-1" style={{ color: "#0041F0" }}>
                  ABC University
                </p>
              </p>
              <NavLink to="/home">
                <img
                  src="images/Home/home-icon-blue.png"
                  class="home-icon"
                  alt="homeicon"
                />
              </NavLink>
            </div>
          </div>
          <div class="searchnav-row">
            <div
              class="searchnav-box"
              style={{ textAlign: "right", marginTop: "10px" }}
            >
              {/* <p>Hello {localStorage.getItem("empName")}!</p> */}
              {/* <p>Hello !</p> */}
              <WelcomeName />
              <img src="images/Avatar.png" class="user-img" alt="user-image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
